// extracted by mini-css-extract-plugin
export default {"wrapper":"Footer_wrapper__VWkKf","inner":"Footer_inner__K9Aq6","link":"Footer_link__yujud","link_icon":"Footer_link_icon__vk9tU"};